import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "certificateFilled"
const CertificateFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M18 9.375C20.485 9.375 22.5 11.39 22.5 13.875 22.5 15.207 21.92 16.405 21 17.228V22.5L18 21 15 22.5V17.228C14.08 16.404 13.5 15.208 13.5 13.875 13.5 11.39 15.515 9.375 18 9.375M18 12C16.965 12 16.125 12.84 16.125 13.875S16.965 15.75 18 15.75 19.875 14.91 19.875 13.875 19.035 12 18 12"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M18.75 1.5C19.993 1.5 21 2.507 21 3.75V8.68C20.117 8.167 19.093 7.874 18 7.874 14.686 7.875 12 10.561 12 13.875 12 15.396 12.57 16.784 13.5 17.84V18H3.75C2.507 18 1.5 16.993 1.5 15.75V3.75C1.5 2.507 2.507 1.5 3.75 1.5zM4.5 8.25V9.75H11.25V8.25zM4.5 5.25V6.75H15V5.25z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default CertificateFilledIcon
